<template>
    <div class="version_page">
      <div class="banner_img">
        <img src="../static/images/version_banner.jpg" class="img" alt="">
      </div>
      <div class="content">
        <p class="tip">如有疑问，请联系客服：400-808-9187</p>
        <div class="content_title">
          <p class="big_size">产品服务比对介绍</p>
          全周期一站式签管一体化平台
        </div>
        <ul class="list_ul">
<!--          头部-->
          <li class="list_li">
            <div class="li_div li_1">
              <p class="bold_title">产品服务</p>
            </div>
            <div class="li_div li_center li_2">
              <p class="bold_title">基础版</p>
              电子合同基本签管能力
            </div>
            <div class="li_div li_3">
              <p class="bold_title">高级版</p>
              满足企业签管一体化需求
            </div>
          </li>
<!--          按钮-->
          <li class="list_li">
            <div class="li_div">-</div>
            <div class="li_div li_center">
              <p class="li_button">默认开通</p>
            </div>
            <div class="li_div li_flex">
              <el-switch
                v-model="switchVal"
                :disabled="switchVal === 2"
                :inactive-value="1"
                :active-value="2"
                @change="switchChangeFn"
                active-color="#ec1c1c">
              </el-switch>
              <span class="flex_text">{{switchVal === 2 ? '已开启' : '已关闭'}}</span>
            </div>
          </li>
          <li class="list_li" v-for="(item, index) in listArr" :key="index">
            <div class="li_div">
              <p class="bold_title">{{item.title}}</p>
              <span>{{item.tip}}</span>
            </div>
            <div class="li_div li_center">
              <i class="el-icon-check" style="color: #00cb14; font-size: 20px; font-weight: bold" v-if="item.text2"></i>
              <i class="el-icon-close" style="color: #ec1c1c; font-size: 20px; font-weight: bold" v-else></i>
            </div>
            <div class="li_div">
              <i class="el-icon-check" style="color: #00cb14; font-size: 20px; font-weight: bold" v-if="item.text3"></i>
              <i class="el-icon-close" style="color: #ec1c1c; font-size: 20px; font-weight: bold" v-else></i>
            </div>
          </li>
          <!--          按钮-->
          <li class="list_li">
            <div class="li_div">-</div>
            <div class="li_div li_center">
              <p class="li_button">默认开通</p>
            </div>
            <div class="li_div li_flex">
              <el-switch
                v-model="switchVal"
                :disabled="switchVal === 2"
                :inactive-value="1"
                :active-value="2"
                @change="switchChangeFn"
                active-color="#ec1c1c">
              </el-switch>
              <span class="flex_text">{{switchVal === 2 ? '已开启' : '已关闭'}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
    import {ApiMethods} from "../assets/js/http-serve/http-methods";
    import {mapGetters} from "vuex";

    export default {
        name: "versionPage",
      data() {
          return {
            switchVal: 1,
            listArr: [
              {
                title: '基础签发',
                tip: '批量发起、签署、下载',
                text2: 1,
                text3: 1,
              },
              {
                title: '模板发起',
                tip: 'html模板、pdf模板、文件模板',
                text2: 0,
                text3: 1,
              },

              {
                title: '批量签发',
                tip: '批量发起、签署、下载',
                text2: 1,
                text3: 1,
              },
              {
                title: '合同管理',
                tip: '合同查询、合同预览、合同下载',
                text2: 1,
                text3: 1,
              },
              {
                title: '合同归档',
                tip: '合同分类归档',
                text2: 1,
                text3: 1,
              },
              {
                title: '企业合同管理',
                tip: '管理企业主账号及成员签/发的合同',
                text2: 0,
                text3: 1,
              },
              {
                title: '水印设置',
                tip: '批量设置合同水印',
                text2: 1,
                text3: 1,

              },
              {
                title: '组织及成员管理',
                tip: '可创建、维护组织架构，管理成员',
                text2: 0,
                text3: 1,
              },
              {
                title: '权限管理',
                tip: '企业成员角色权限组配置',
                text2: 0,
                text3: 1,
              },
              {
                title: '印章管理',
                tip: '印章创建、修改、删除',
                text2: 1,
                text3: 1,
              },
              {
                title: '印章授权',
                tip: '可将印章授权给成员，由成员代表企业签署合同',
                text2: 0,
                text3: 1,
              },
              {
                title: '模板管理',
                tip: '合同模板创建、修改、批量发起',
                text2: 0,
                text3: 1,
              },
              {
                title: '模板授权',
                tip: '可将模板授权给成员使用',
                text2: 0,
                text3: 1,
              },
              {
                title: '合同审批',
                tip: '支持合同发起审批及用印审批',
                text2: 0,
                text3: 1,
              },
              {
                title: 'AI合同机器人',
                tip: '合同协同起草、法律风险审查、关键词抽取、合同比对',
                text2: 1,
                text3: 1,
              },
              {
                title: '司法服务',
                tip: '在线出证(公证保管函，E证据)、一键司法仲裁',
                text2: 1,
                text3: 1,
              },
            ],
          }
      },
      mounted() {
          this.init();
      },
      computed: {
        ...mapGetters(["currentAuthUser", "allAuthUser"]),
      },
      methods: {
        init() {
          this.switchVal = Number(this.allAuthUser.accountInfoVO.layoutVersion)
        },
        switchChangeFn() {
          ApiMethods.ProfileController.setLayoutVersion({
            layoutVersion: this.switchVal,
          }).then(res => {
            if(res.success) {
              this.$message.success('高级版已' + (this.switchVal === 1 ? '关闭' : '开启'))
              this.$router.push('/viewIndex')
            }
          })
        },
      }
    }
</script>

<style scoped lang="less">
@import url('../assets/style/cssVariable.less');
  .version_page {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    overflow-y: scroll;
    height: calc(100vh - 100px);
    background-color: @ebq-white;
  }
  .banner_img {
   .img {
     max-width: 100%;
   }
  }
  .content {
    background-color: @ebq-white;
    width: 1200px;
    margin: 20px auto;
    padding: 10px 20px;
    border-radius: 2px;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.3);
    .tip {
      font-weight: bold;
      font-size: 14px;
    }
    .content_title {
      text-align: center;
      font-size: 14px;
      margin: 10px 0;
      .big_size {
        font-weight: bold;
        font-size: 18px;
      }
    }
    .list_ul {
      border: 1px solid @ebq-grey-white7;
      .list_li {
        display: flex;
        justify-content: space-evenly;
        border-bottom: 1px solid @ebq-grey-white7;
        &:last-child {
          border: none;
        }
        .li_div {
          width: 33.3%;
          flex-shrink: 0;
          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: center;
          padding: 10px 0;
          &.li_flex {
            flex-flow: row;
            .flex_text {
              margin-left: 6px;
              font-size: 12px;
            }
          }
          &.li_center {
            border-left: 1px solid @ebq-grey-white7;
            border-right: 1px solid @ebq-grey-white7;
          }
          &.li_1 {}
          &.li_2 {
            background-color: @ebq-grey-white8;
          }
          &.li_3 {
            background-color: #fdedd8;
            color: #ff8a00;
          }
          .bold_title {
            font-weight: bold;
          }
          .li_button {
            /*border: 1px solid #797979;*/
            /*border-radius: 6px;*/
            /*padding: 4px 20px;*/
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/versionPage.vue